var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: "78.221886mm",
    height: "78.221886mm",
    viewBox: "0 0 78.221886 78.221886",
    id: "svg3108",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-51.202763,-72.621029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51007,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 90.313705,
    cy: 111.73197,
    rx: 35.855999,
    ry: 35.855907
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5825",
    transform: "matrix(0.0930641,0.06819744,-0.06819744,0.0930641,81.317211,76.033457)",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5743",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5741",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 253.476,358.88 c -24.24,0 -43.96,19.656 -43.96,43.804 0,24.156 19.72,43.82 43.96,43.82 24.248,0 43.968,-19.664 43.968,-43.82 0,-24.148 -19.724,-43.804 -43.968,-43.804 z",
    id: "path5739",
    style: {
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5749",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5747",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 360.732,299.197 c -28.62,-28.604 -66.716,-44.364 -107.256,-44.364 -40.384,0 -78.376,15.656 -106.988,44.08 -11.556,11.5 -11.576,30.236 -0.048,41.756 5.6,5.608 13.056,8.688 20.992,8.688 7.9,0 15.328,-3.064 20.92,-8.624 17.412,-17.304 40.54,-26.836 65.124,-26.836 24.676,0 47.868,9.592 65.292,27 5.6,5.592 13.052,8.68 20.98,8.68 7.908,0 15.332,-3.064 20.928,-8.624 11.572,-11.501 11.592,-30.228 0.056,-41.756 z",
    id: "path5745",
    style: {
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5755",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5753",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 498.512,161.872 C 433.08,96.601 346.052,60.665 253.476,60.665 c -92.452,0 -179.392,35.852 -244.804,100.968 -11.556,11.5 -11.564,30.236 -0.016,41.756 5.596,5.58 13.04,8.648 20.96,8.648 7.916,0 15.352,-3.056 20.948,-8.632 54.22,-53.968 126.28,-83.696 202.912,-83.696 76.744,0 148.876,29.788 203.108,83.9 5.596,5.584 13.052,8.664 20.968,8.664 7.912,0 15.348,-3.072 20.94,-8.64 11.56,-11.509 11.572,-30.252 0.02,-41.761 z",
    id: "path5751",
    style: {
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5761",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5759",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 427.876,232.256 C 381.3,185.788 319.364,160.2 253.476,160.2 c -65.768,0 -127.612,25.508 -174.148,71.812 -5.604,5.572 -8.688,12.984 -8.7,20.876 0,7.884 3.072,15.304 8.668,20.884 5.596,5.584 13.044,8.664 20.964,8.664 7.908,0 15.344,-3.072 20.948,-8.632 35.352,-35.172 82.328,-54.548 132.268,-54.548 50.044,0 97.084,19.444 132.46,54.736 5.604,5.592 13.048,8.672 20.972,8.672 7.912,0 15.352,-3.072 20.94,-8.64 5.596,-5.572 8.688,-12.984 8.692,-20.876 0.008,-7.892 -3.072,-15.304 -8.664,-20.892 z",
    id: "path5757",
    style: {
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5763",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5765",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5767",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5769",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5771",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5773",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5775",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5777",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5779",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5781",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5783",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5785",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5787",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5789",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5791",
    style: {
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.2a46e7476cf1c5a21d9c4fa9071916b5.svg";
export { ForwardRef as ReactComponent };